import { useRef } from 'react';
import useFrameSize from '../../hooks/useFrameSize';
import { FrameProvider } from '../../contexts/FrameContext';

/** Teacher shell <main>: exposes data-frame="compact|medium|wide" (CSS) and FrameContext (JS) (VIS1 G1). */
export default function ShellMain({ children }) {
  const ref = useRef(null);
  const frame = useFrameSize(ref);
  return (
    <main ref={ref} className="main-content" data-frame={frame}>
      <FrameProvider value={frame}>{children}</FrameProvider>
    </main>
  );
}
